import { useEffect, useState } from "react";
import { Flex, Space, Spin, Typography } from "antd";
import { useTranslate } from "@refinedev/core";
import type { BundleResponse } from "@/types";

const formatElapsed = (ms: number) => {
  const totalSeconds = Math.max(0, Math.floor(ms / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
};

type ExportInProgressCardProps = {
  bundle: BundleResponse;
};

export const ExportInProgressCard = ({ bundle }: ExportInProgressCardProps) => {
  const t = useTranslate();
  const startedAt = Date.parse(bundle.requested_at);
  const [elapsedMs, setElapsedMs] = useState(() => Date.now() - startedAt);

  useEffect(() => {
    const interval = setInterval(() => {
      setElapsedMs(Date.now() - startedAt);
    }, 1000);
    return () => clearInterval(interval);
  }, [startedAt]);

  return (
    <Space align="center" size="large">
      <Spin />
      <Flex vertical gap="small">
        <Typography.Text strong>
          {t("media.organizations.dataExport.preparing")}
        </Typography.Text>
        <Typography.Text
          type="secondary"
          style={{ fontVariantNumeric: "tabular-nums" }}
        >
          {t("media.organizations.dataExport.elapsed", {
            time: formatElapsed(elapsedMs),
          })}
        </Typography.Text>
      </Flex>
    </Space>
  );
};
